<template>
  <div class="tinymce-editor">
    <editor ref="tEditor" v-model="myValue" :init="init" :placeholder="placeholderHtml" :disabled="disabled" @onClick="onClick"></editor>
  </div>
</template>

<script type="text/javascript">
/* eslint-disable */
    import lrz from 'lrz';
    import tinymce from 'tinymce/tinymce';
    import Editor from '@tinymce/tinymce-vue';
    import 'tinymce/themes/silver/theme';
    import 'tinymce/plugins/image';
    import 'tinymce/plugins/media';
    import 'tinymce/plugins/table';
    import 'tinymce/plugins/lists';
    import 'tinymce/plugins/contextmenu';
    import 'tinymce/plugins/wordcount';
    import 'tinymce/plugins/colorpicker';
    import 'tinymce/plugins/textcolor';
    import 'tinymce/plugins/codesample';
    import 'tinymce/plugins/code';
    import 'tinymce/plugins/link';
    import 'tinymce/plugins/fullscreen';
    import 'tinymce/plugins/preview';
    import 'tinymce/plugins/quickbars';
    import 'tinymce/icons/default/icons.min.js';
    export default {
        name: 'TinymceEditor',
        components: {
            Editor
        },
        props: {
            // 传入一个value，使组件支持v-model绑定
            value: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: '请输入'
            },
            disabled: {
                type: Boolean,
                default: false
            },
            height: {
                type: Number,
                default: 400
            },
            plugins: {
                type: [String, Array],
                default:
                    'link lists image media table textcolor wordcount contextmenu codesample code fullscreen preview quickbars'
            },
            toolbar: {
                type: [String, Array],
                default:
                    'undo redo | fontselect formatselect fontsizeselect | bold italic forecolor backcolor | link underline strikethrough superscript| alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | image media table |  removeformat codesample code preview fullscreen'
            },
            images_upload_handler: {
                type: Function,
                default: null
            }
        },
        data() {
            return {
                // 初始化配置
                placeholderHtml: this.placeholder,
                init: {
                    formats: {},
                    height: this.height,
                    language_url: './static/tinymce/zh_CN.js',
                    language: 'zh_CN',
                    skin_url: './static/tinymce/skins/ui/oxide',
                    plugins: this.plugins,
                    toolbar: this.toolbar,
                    quickbars_insert_toolbar: '',
                    branding: false,
                    menubar: false,
                    convert_urls: false,
                    // 此处为图片上传处理函数，这个直接用了base64的图片形式上传图片，
                    // 如需ajax上传可参考https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_handler
                    images_upload_handler: (blobInfo, success) => {
                        let size = blobInfo.blob().size / 1024 / 1024;
                        console.log('开始压缩图片');
                        console.log(size.toFixed(2), 'mb------压缩前大小');
                        console.log(blobInfo.base64().length, '------压缩前base64长度');
                        lrz(blobInfo.blob(), [
                            {
                                quality: 0.8
                            }
                        ])
                            .then((rst) => {
                                let size = rst.file.size / 1024 / 1024;
                                console.log(size.toFixed(2), 'mb------压缩后大小');
                                console.log(rst.base64Len, '------压缩前base64长度');
                                if (this.images_upload_handler) {
                                    this.images_upload_handler(rst, success);
                                } else {
                                    // 成功时执行
                                    success(rst.base64);
                                }
                            })
                            .catch((error) => {
                                console.log(error, 'error');
                                alert('图片压缩失败');
                            // 失败时执行
                            })
                            .always(() => {
                            // 不管成功或失败，都会执行
                        });
                    }
                },
                myValue: this.value,
                charlimit: 10,
                length: 0
            };
        },
        mounted() {
            tinymce.init({});
        },
        methods: {
            // 添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
            // 需要什么事件可以自己增加
            onClick(e) {
                this.$emit('onClick', e, tinymce);
            },
            // 可以添加一些自己的自定义事件，如清空内容
            clear() {
                this.myValue = '';
            },
            contentChange() {
                let text = this.$refs.tEditor.editor.getContent();
                this.length = text.length;
            },
            getLength() {
                return this.length;
            },
            getEditor() {
                if (this.$refs.tEditor && this.$refs.tEditor.editor) {
                    return this.$refs.tEditor.editor;
                }
                return null;
            },
        },
        watch: {
            value(newValue) {
                this.myValue = newValue;
                this.contentChange();
            },
            myValue(newValue) {
                this.$emit('input', newValue);
            }
        }
    };
</script>

<style lang="less">
.tox {
  z-index: 10000000000000;
}
.tox-tinymce {
    border-radius: 4px !important;
    border: 0px !important;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 12px 0px !important;
}
.tox .tox-toolbar__primary {
    border-top: 0px !important;
}
.tox .tox-tbtn svg {
    fill: #7d7d7d !important;
}
.tox:not([dir='rtl']) .tox-toolbar__group:not(:last-of-type) {
    // border-right: 1px solid rgba(204, 204, 204, 0.32) !important;
    border-right: 0px !important;
}
.tox-toolbar__group:after {
    display: inline-block;
    width: 1px;
    height: 20px;
    content: ' ';
    background: #e8e8e8;
    margin-left: 10px;
}
.tox .tox-edit-area {
    border-top: 1px solid #f1f1f1 !important;
}
.tox .tox-statusbar {
    border-top: 1px solid #f1f1f1 !important;
}
.tox-fullscreen .tox.tox-tinymce.tox-fullscreen {
    z-index: 100000 !important;
}
.tox .tox-dialog {
    border-color: rgba(204, 204, 204, 0.4) !important;
}
.tox .tox-dialog__footer {
    border-top: 1px solid rgba(204, 204, 204, 0.4) !important;
}
.tox-silver-sink{
  z-index: 3300 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/webpc/TinymceEditor/index.vue